// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-time-col {
  display: flex;
  align-items: center;
  height: 6rem;
  font-size: 0.75rem;
}
.calendar-time-col p {
  width: 4rem;
  min-width: 4rem;
  text-align: center;
  font-weight: bold;
}

.calendar-time-divider {
  background-color: #d1d1d1;
  height: 1px;
  width: 100%;
}

.calendar-event {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
  height: 0;
  padding: 1.5px !important;
}
.calendar-event .green {
  background-color: rgba(57, 209, 87, 0.1019607843);
  border-left: 2px solid #39d157;
}
.calendar-event .red {
  background-color: rgba(237, 20, 61, 0.2);
  border-left: 2px solid #ed143d;
}
.calendar-event div {
  box-sizing: border-box;
  border-radius: 0.25rem;
  width: 100%;
  display: flex;
  flex-direction: column !important;
}
.calendar-event span {
  font-size: 0.75rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-events-container {
  position: absolute;
  top: 3rem;
  left: 4rem;
  right: 0.5rem;
  bottom: 2rem;
}
.calendar-events-container div {
  font-size: 1rem;
  margin: 0 !important;
  display: flex;
  flex-direction: row;
  padding-inline: 4px;
  padding-top: 2px;
}

.calendar-current-time {
  position: absolute;
  width: calc(100% - 0.5rem);
  height: 6rem;
  font-size: 0.75rem;
  z-index: 20;
  margin-inline: 0.25rem;
}
.calendar-current-time .calendar-current-time-chip {
  position: absolute;
  top: calc(2.4rem + 1px);
  z-index: 11;
  background-color: #e0061c;
  color: white;
  border-radius: 1rem;
  width: 3.5rem;
  height: 1.2rem;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.calendar-current-time .calendar-current-time-line {
  position: absolute;
  top: 3rem;
  background-color: #e0061c;
  height: 2px;
  width: 100%;
  border-radius: 8px;
}

.calendar-grid {
  position: relative;
  padding-right: 0.5rem;
  height: 100%;
  overflow-y: scroll;
}`, "",{"version":3,"sources":["webpack://./src/app/calendar-view/calendar/calendar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,WAAA;EACA,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;AAAF;AAEE;EACE,iDAAA;EACA,8BAAA;AAAJ;AAEE;EACE,wCAAA;EACA,8BAAA;AAAJ;AAGE;EACE,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,iCAAA;AADJ;AAIE;EACE,6BAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;AAHF;AAKE;EACE,eAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,kBAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AAJF;AAME;EACE,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AALJ;;AASA;EACE,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AANF","sourcesContent":[".calendar-time-col {\n  display: flex;\n  align-items: center;\n  height: 6rem;\n  font-size: 0.75rem;\n\n  p {\n    width: 4rem;\n    min-width: 4rem;\n    text-align: center;\n    font-weight: bold;\n  }\n}\n\n.calendar-time-divider {\n  background-color: #d1d1d1;\n  height: 1px;\n  width: 100%;\n}\n\n.calendar-event {\n  position: absolute;\n  box-sizing: border-box;\n  width: 100%;\n  overflow: hidden;\n  height: 0;\n  padding: 1.5px !important;\n\n  .green {\n    background-color: #39d1571a;\n    border-left: 2px solid #39d157;\n  }\n  .red {\n    background-color: #ed143d33;\n    border-left: 2px solid #ed143d;\n  }\n\n  div {\n    box-sizing: border-box;\n    border-radius: 0.25rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column !important;\n  }\n\n  span {\n    font-size: 0.75rem !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.calendar-events-container {\n  position: absolute;\n  top: 3rem;\n  left: 4rem;\n  right: 0.5rem;\n  bottom: 2rem;\n\n  div {\n    font-size: 1rem;\n    margin: 0 !important;\n    display: flex;\n    flex-direction: row;\n    padding-inline: 4px;\n    padding-top: 2px;\n  }\n}\n\n.calendar-current-time {\n  position: absolute;\n  width: calc(100% - 0.5rem);\n  height: 6rem;\n  font-size: 0.75rem;\n  z-index: 20;\n  margin-inline: 0.25rem;\n\n  .calendar-current-time-chip {\n    position: absolute;\n    top: calc(2.4rem + 1px);\n    z-index: 11;\n    background-color: #e0061c;\n    color: white;\n    border-radius: 1rem;\n    width: 3.5rem;\n    height: 1.2rem;\n    font-size: 0.75rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .calendar-current-time-line {\n    position: absolute;\n    top: 3rem;\n    background-color: #e0061c;\n    height: 2px;\n    width: 100%;\n    border-radius: 8px;\n  }\n}\n\n.calendar-grid {\n  position: relative;\n  padding-right: 0.5rem;\n  height: 100%;\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
